import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from '../../api/axios';
import AdminLayout from '../../layouts/AdminLayout';
import { BsCalendarCheck, BsCashCoin, BsBasket } from 'react-icons/bs';

const Reports = () => {
    const { t } = useTranslation();
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [reportData, setReportData] = useState(null);

    const fetchReport = async () => {
        try {
            const res = await axios.get('/reports/general', {
                params: { startDate, endDate }
            });
            setReportData(res.data);
        } catch (error) {
            console.error('Rapor alınamadı');
        }
    };

    useEffect(() => {
        // Varsayılan olarak bu ayın raporunu getir
        const date = new Date();
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1).toISOString().split('T')[0];
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).toISOString().split('T')[0];
        setStartDate(firstDay);
        setEndDate(lastDay);
    }, []);

    useEffect(() => {
        if (startDate && endDate) {
            fetchReport();
        }
    }, [startDate, endDate]);

    return (
        <AdminLayout>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2>{t('reports.title')}</h2>
                <div className="d-flex gap-2">
                    <input type="date" className="form-control" value={startDate} onChange={e => setStartDate(e.target.value)} />
                    <input type="date" className="form-control" value={endDate} onChange={e => setEndDate(e.target.value)} />
                    <button className="btn btn-primary" onClick={fetchReport}>{t('reports.fetch')}</button>
                </div>
            </div>

            {reportData && (
                <>
                    {/* Özet Kartlar */}
                    <div className="row mb-4">
                        <div className="col-md-4">
                            <div className="card shadow-sm border-0 bg-primary text-white">
                                <div className="card-body d-flex align-items-center">
                                    <div className="icon-box bg-white text-primary rounded-circle me-3">
                                        <BsCashCoin size={24} />
                                    </div>
                                    <div>
                                        <h6 className="mb-1 opacity-75">{t('reports.total_revenue')}</h6>
                                        <h3 className="mb-0 fw-bold">{Number(reportData.summary.total_revenue || 0).toLocaleString('tr-TR', { style: 'currency', currency: 'EUR' })}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card shadow-sm border-0 bg-success text-white">
                                <div className="card-body d-flex align-items-center">
                                    <div className="icon-box bg-white text-success rounded-circle me-3">
                                        <BsBasket size={24} />
                                    </div>
                                    <div>
                                        <h6 className="mb-1 opacity-75">{t('reports.total_orders')}</h6>
                                        <h3 className="mb-0 fw-bold">{reportData.summary.total_orders}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card shadow-sm border-0 bg-info text-white">
                                <div className="card-body d-flex align-items-center">
                                    <div className="icon-box bg-white text-info rounded-circle me-3">
                                        <BsCalendarCheck size={24} />
                                    </div>
                                    <div>
                                        <h6 className="mb-1 opacity-75">{t('reports.avg_order_value')}</h6>
                                        <h3 className="mb-0 fw-bold">{Number(reportData.summary.avg_order_value || 0).toLocaleString('tr-TR', { style: 'currency', currency: 'EUR' })}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Ürün Bazlı Satış Tablosu */}
                    <div className="card shadow-sm">
                        <div className="card-header bg-white py-3">
                            <h5 className="m-0 fw-bold">{t('reports.product_performance')}</h5>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>{t('reports.product_name')}</th>
                                        <th className="text-center">{t('reports.sold_quantity')}</th>
                                        <th className="text-end">{t('reports.total_income')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reportData.products.map((prod, idx) => (
                                        <tr key={idx}>
                                            <td>{prod.name}</td>
                                            <td className="text-center">{prod.quantity}</td>
                                            <td className="text-end fw-bold">{Number(prod.revenue).toLocaleString('tr-TR', { style: 'currency', currency: 'EUR' })}</td>
                                        </tr>
                                    ))}
                                    {reportData.products.length === 0 && (
                                        <tr><td colSpan="3" className="text-center p-4">{t('reports.no_data')}</td></tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>
            )}
        </AdminLayout>
    );
};

export default Reports;
